import React from 'react';
import { useParams, matchPath ,useLocation } from 'react-router-dom';

const withRouter = WrappedComponent => props => {
  const params = useParams();
  const location = useLocation();
  const m = matchPath({ path: "/:first/*" }, location.pathname);
  var slug = "";
    if (m?.params?.first) slug= m.params.first;

     const paramsValues = Object.values(params || {});
    if (paramsValues.length) slug= paramsValues[0];

     const parts = String(location.pathname).split("/").filter(Boolean);
      slug=  parts.length ? parts[0] : null;

  return (
    
    <WrappedComponent
      {...props}
      params={params}
      slug={slug}
    />
  );
};

export default withRouter;